import { Trans, useTranslation } from "@coworker/locales";
import { CardHeadLine } from "../../Molecules/Settings/CardHeadLine";
import {
  CardFrame,
  FullLine,
  PaddedContainer,
  WhiteSpace,
} from "../../styles/styles";
import { Media, RoomType } from "../../types/media";
import { getMediaTypeText, getTranslationKeyForRoomType } from "../../tools";
import { MediaTypes, RoomTypes } from "../../constants";

interface AboutRoomProps {
  media: Media;
}

export const AboutRoom = ({ media }: AboutRoomProps) => {
  const { t } = useTranslation();
  return (
    <CardFrame>
      <CardHeadLine
        character={"2"}
        headline={t(`aboutString`, {
          name: getMediaTypeText(MediaTypes.ROOM),
        })}
      />
      <FullLine />
      <PaddedContainer $py="0px" $px="24px">
        <Trans>
          {getTranslationKeyForRoomType(
            (media as RoomType).roomType ?? RoomTypes.NONE
          )}
        </Trans>
        <WhiteSpace height={"12"} />
      </PaddedContainer>
    </CardFrame>
  );
};
